export enum CalendarType {
  Line = 'line',
  Compact = 'compact',
}
